import '@styles/main.scss';

if (import.meta.env.DEV) {
  import('../styles/common/_global.scss');
}

/**
 * ---------------------------------------------------------
 * IMPORT SHARED CORE FROM PARENT
 * ---------------------------------------------------------
 */

import {
  hasElement,
  ensureFlickity,
  ensureModal,
  // ensureCollapse,
  // ensureSelect2,
} from '../../../../roots/resources/assets/scripts/main';

import initCommon from './common/common';
import componentRegistry from './component-registry.json';

/**
 * ---------------------------------------------------------
 * COMPONENT REGISTRY
 * ---------------------------------------------------------
 */

const componentDependencies = {
  flickity: ensureFlickity,
  modal: ensureModal,
};

const componentLoaders = {
  ...import.meta.glob('./components/**/index.js'),
  './components/misc/flickityAdditions.js': () => import('./components/misc/flickityAdditions'),
  './components/misc/editorContentAdditions.js': () => import('./components/misc/editorContentAdditions'),
  './components/misc/jqueryViewer.js': () => import('./components/misc/jqueryViewer'),
  './components/woocommerce/cartSection.js': () => import('./components/woocommerce/cartSection'),
  './components/woocommerce/checkoutSection.js': () => import('./components/woocommerce/checkoutSection'),
  './components/woocommerce/orderReceivedSection.js': () => import('./components/woocommerce/orderReceivedSection'),
  './components/woocommerce/productCard.js': () => import('./components/woocommerce/productCard'),
  './components/woocommerce/quantitySelector.js': () => import('./components/woocommerce/quantitySelector'),
  './components/woocommerce/relatedProducts.js': () => import('./components/woocommerce/relatedProducts'),
};

const components = componentRegistry
  .map((component) => ({
    ...component,
    dependencies: (component.dependencies || [])
      .map((dependency) => componentDependencies[dependency])
      .filter(Boolean),
    child: componentLoaders[`./${component.entry.replace(/^scripts\//, '')}`],
  }))
  .filter((component) => component.child);

/**
 * ---------------------------------------------------------
 * HELPERS
 * ---------------------------------------------------------
 */

function sleep(ms) {
  return new Promise((resolve) =>
    setTimeout(resolve, ms)
  );
}

/**
 * ---------------------------------------------------------
 * COMPONENT LOADER
 * ---------------------------------------------------------
 */

async function loadComponent(component) {
  const {
    selector,
    child,
    // parent,
    dependencies = [],
    delay = 0,
  } = component;

  if (!hasElement(selector)) {
    return;
  }

  await Promise.all(
    dependencies.map((dependency) => dependency())
  );

  if (delay) {
    await sleep(delay);
  }

  let module = null;

  /**
   * TRY CHILD FIRST
   */

  try {
    module = await child();

    console.log(`[Child Loaded] ${selector}`);
  } catch (error) {
    console.error(
    '[Child Import Failed]',
    selector,
    error
  );

  return;

    /**
     * FALLBACK TO PARENT
     */

    // try {
    //   module = await parent();

    //   console.log(`[Parent Fallback] ${selector}`);
    // } catch (parentError) {
    //   console.error(
    //     `[Component Missing] ${selector}`,
    //     parentError
    //   );

    //   return;
    // }
  }

  if (
    module?.default &&
    typeof module.default === 'function'
  ) {
    module.default();
  }
}

/**
 * ---------------------------------------------------------
 * INIT
 * ---------------------------------------------------------
 */

// async function loadGlobalOverrides() {
//   await import('@styles/common/_global.scss');
// }

async function initTheme() {
  initCommon(ensureModal);

  await Promise.allSettled(
    components.map((component) =>
      loadComponent(component)
    )
  );

  // await loadGlobalOverrides();
}

$(document).ready(function () {
  initTheme();
});
